<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR_ID')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.userId }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LOGIN_ID')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.loginId }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EPID')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.epid }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EPNO')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.employeeIDNumber }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_KNOX_ID')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.knoxId }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR_NM')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.userName }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_GLBL_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.userGlobalName }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EMAIL')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.email }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_CD')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.companyCode }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.companyName }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_EN_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.companyEnglishName }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEPT_ID')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.departmentId }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEPT_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.departmentName }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DEPT_EN_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.departmentEnglishName }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CRLV_CD')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.careerLevelCode }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CRLV_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.careerLevelName }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CRLV_EN_NM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.careerLevelEnglishName }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CP')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.cellphone }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_CPNY_CONTA')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.companyContactAddr }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PBLC_ID_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="objUserMaster.publicIdYn"
              value="Y"
              :disabled="true"
            >
              {{ 'Yes' }}
            </sui-radio>
            <sui-radio
              v-model="objUserMaster.publicIdYn"
              value="N"
              :disabled="true"
            >
              {{ 'No' }}
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_EMPL_INFO_FNL_CHG_DT')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.empInfoFinalChangeDT }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_REAL_USE_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="objUserMaster.userRealityUseYn"
              value="Y"
              :disabled="true"
            >
              {{ 'Yes' }}
            </sui-radio>
            <sui-radio
              v-model="objUserMaster.userRealityUseYn"
              value="N"
              :disabled="true"
            >
              {{ 'No' }}
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_TYPE_CD')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.userTypeCode }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USR_BLNG_TYPE_CD')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.userBelongingTypeCode }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_IRSD_STT_CD')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.servedStateCode }}</div>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DSPL_LNG_ID')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">{{ objUserMaster.displayLangId }}</div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onListClick"
        >
          {{ $t("MSG_BTN_LIST") }}
        </sui-button>  
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00036', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      queryData: {},
      objUserMaster: {
        userId: '',
        loginId: '',
        epid: '',
        employeeIDNumber: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        email: '',
        companyCode: '',
        companyName: '',
        companyEnglishName: '',
        departmentId: '',
        departmentName: '',
        departmentEnglishName: '',
        careerLevelCode: '',
        careerLevelName: '',
        careerLevelEnglishName: '',
        cellphone: '',
        companyContactAddr: '',
        publicIdYn: '',
        empInfoFinalChangeDT: '',
        userRealityUseYn: '',
        userTypeCode: '',
        userBelongingTypeCode: '',
        servedStateCode: '',
        displayLangId: '',
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.queryData = utils.getParameter(this, 'queryData');
      this.loadUserMaster();
    },
    loadUserMaster() {
      const userId = utils.getParameter(this, 'userId');
      if(!utils.isEmpty(userId)) {
        http.requestTest('get', `/api/v1/common/user-master/${userId}`, {
        //http.request(this.contextPageId, 'DTS_XXX_XXXXX', {  
          path: {
            'user-id': userId,
          },
        }).then(res => {
          this.objUserMaster = res.data;
        });
      }
    },
    onListClick() {
      utils.goPage('PGE_CMY_00033', {
        queryData: this.queryData,
      });
    },
  },
};
</script>

<style scoped>
</style>
